import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enteredSchool, setEnteredSchool] = useState(() =>
    localStorage.getItem("ah_school")
      ? { id: localStorage.getItem("ah_school"), name: localStorage.getItem("ah_school_name") }
      : null
  );

  useEffect(() => {
    const token = localStorage.getItem("ah_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("ah_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    localStorage.removeItem("ah_school");
    localStorage.removeItem("ah_school_name");
    setEnteredSchool(null);
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ah_token", r.data.token);
    if (r.data.user.role === "super_admin") localStorage.setItem("ah_is_super", "1");
    else localStorage.removeItem("ah_is_super");
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("ah_token");
    localStorage.removeItem("ah_school");
    localStorage.removeItem("ah_school_name");
    localStorage.removeItem("ah_is_super");
    setUser(null);
    setEnteredSchool(null);
  };

  const loginWithToken = (token, userObj) => {
    localStorage.setItem("ah_token", token);
    setUser(userObj);
  };

  const enterSchool = async (school) => {
    localStorage.setItem("ah_school", school.id);
    localStorage.setItem("ah_school_name", school.name);
    setEnteredSchool(school);
    const r = await api.get("/auth/me");
    setUser(r.data);
  };

  const exitSchool = async () => {
    localStorage.removeItem("ah_school");
    localStorage.removeItem("ah_school_name");
    setEnteredSchool(null);
    const r = await api.get("/auth/me");
    setUser(r.data);
  };

  const isSuper = localStorage.getItem("ah_is_super") === "1";

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loginWithToken, loading, isSuper, enteredSchool, enterSchool, exitSchool }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
